import template from '../ui/templates/modal/add-page.hbs';

class ModalAddPage {
  constructor (opts) {
    this.opts = $.extend(
      {
        baseUrl: INKIVE.C.BASE_URL,
        staticUrl: INKIVE.C.STATIC_URL
      },
      opts
    );

    this.$wrapper = $(
      this.opts.wrapper
        ? this.opts.wrapper
        : '<div style="padding-top: 10px;"></div>'
    );

    this.$wrapper.append(template());
  }

  getFormHtml () {
    return this.$wrapper;
  }

  saveForm (callback) {
    callback && callback(true);
  }
}

module.exports = ModalAddPage;
